export default __webpack_public_path__ + "static/media/motivation.bfce0f73.svg";